// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LAKPED-16.4 — la hoja de oferta. Mismos valores que el prototipo de Paula (pantalla \`of_pdf\`):
   la hoja a la izquierda con aspecto de papel y el envío en una columna a la derecha.
   Lo que se ve en la hoja es lo que se imprime: en @media print se quita todo lo demás.
   Acotado a .offer-pdf porque el CSS de CRA es global. */

.offer-pdf {
  max-width: 1200px;
  margin: 0 auto;
  padding: 28px 32px 60px;
}

.offer-pdf-error { color: #b71c1c; font-size: 14px; }

/* Pasos */
.offer-pdf-pasos {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  list-style: none;
  margin: 0 0 20px;
  padding: 0;
}

.offer-pdf-pasos li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #333;
  background: #fff;
  border: 1px solid #e3e3e3;
  border-radius: 20px;
  padding: 5px 14px 5px 6px;
}

.offer-pdf-paso-num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #1a9b5a;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
}

.offer-pdf-pasos li.hecho { padding: 0; }
.offer-pdf-pasos li.hecho button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 14px 5px 6px;
  border: none;
  background: none;
  font: inherit;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  border-radius: 20px;
}
.offer-pdf-pasos li.hecho button:hover:not(:disabled) { background: #f2f2f2; text-decoration: underline; }
.offer-pdf-pasos li.hecho button:disabled { cursor: default; color: #999; }
.offer-pdf-pasos li.actual { color: #111; border-color: #111; font-weight: 600; }
.offer-pdf-pasos li.actual .offer-pdf-paso-num { background: #111; color: #fff; }

/* Hoja a la izquierda, envío a la derecha */
.offer-pdf-columnas {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 16px;
  align-items: start;
}

/* Envío */
.offer-pdf-envio {
  background: #fff;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  padding: 18px 20px;
  margin-bottom: 16px;
}

.offer-pdf-envio h2 { font-size: 15px; font-weight: 600; margin: 0 0 12px; color: #1b1b1b; }
.offer-pdf-envio p { font-size: 13.5px; color: #666; margin: 0 0 12px; }

.offer-pdf-acciones { display: flex; flex-wrap: wrap; gap: 10px; }

.offer-pdf-secundario,
.offer-pdf-principal {
  border-radius: 8px;
  padding: 9px 16px;
  font: inherit;
  font-size: 14px;
  cursor: pointer;
}

.offer-pdf-secundario { background: #fff; border: 1px solid #bbb; color: #111; }
.offer-pdf-secundario:hover:not(:disabled) { background: #eee; }
.offer-pdf-secundario:disabled { background: #eee; color: #999; border-color: #ddd; cursor: default; }
.offer-pdf-principal { background: #111; border: 1px solid #111; color: #fff; }
.offer-pdf-principal:hover { background: #333; }

.offer-pdf-estado { font-size: 12.5px; color: #777; margin: 12px 0 0; }

/* Lo que sale de casa: solo la hoja */
@media print {
  body { background: #fff !important; }
  .header, .offer-pdf-pasos, .offer-pdf-lateral { display: none !important; }
  .offer-pdf { padding: 0; max-width: 100%; }
  .offer-pdf-columnas { display: block; }
}

@media (max-width: 900px) {
  .offer-pdf { padding: 20px 16px 40px; }
  .offer-pdf-columnas { grid-template-columns: 1fr; }
  .offer-pdf .offer-pdf-hoja { padding: 20px; min-height: 0; overflow-x: auto; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/OfferPdfPage.css"],"names":[],"mappings":"AAAA;;;yDAGyD;;AAEzD;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA,mBAAmB,cAAc,EAAE,eAAe,EAAE;;AAEpD,UAAU;AACV;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,4BAA4B,UAAU,EAAE;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;AACA,wDAAwD,mBAAmB,EAAE,0BAA0B,EAAE;AACzG,4CAA4C,eAAe,EAAE,WAAW,EAAE;AAC1E,6BAA6B,WAAW,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAChF,iDAAiD,gBAAgB,EAAE,WAAW,EAAE;;AAEhF,4CAA4C;AAC5C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC3F,qBAAqB,iBAAiB,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAEvE,sBAAsB,aAAa,EAAE,eAAe,EAAE,SAAS,EAAE;;AAEjE;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA,wBAAwB,gBAAgB,EAAE,sBAAsB,EAAE,WAAW,EAAE;AAC/E,6CAA6C,gBAAgB,EAAE;AAC/D,iCAAiC,gBAAgB,EAAE,WAAW,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACrG,uBAAuB,gBAAgB,EAAE,sBAAsB,EAAE,WAAW,EAAE;AAC9E,6BAA6B,gBAAgB,EAAE;;AAE/C,oBAAoB,iBAAiB,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAEtE,sCAAsC;AACtC;EACE,OAAO,2BAA2B,EAAE;EACpC,gDAAgD,wBAAwB,EAAE;EAC1E,aAAa,UAAU,EAAE,eAAe,EAAE;EAC1C,sBAAsB,cAAc,EAAE;AACxC;;AAEA;EACE,aAAa,uBAAuB,EAAE;EACtC,sBAAsB,0BAA0B,EAAE;EAClD,6BAA6B,aAAa,EAAE,aAAa,EAAE,gBAAgB,EAAE;AAC/E","sourcesContent":["/* LAKPED-16.4 — la hoja de oferta. Mismos valores que el prototipo de Paula (pantalla `of_pdf`):\n   la hoja a la izquierda con aspecto de papel y el envío en una columna a la derecha.\n   Lo que se ve en la hoja es lo que se imprime: en @media print se quita todo lo demás.\n   Acotado a .offer-pdf porque el CSS de CRA es global. */\n\n.offer-pdf {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 28px 32px 60px;\n}\n\n.offer-pdf-error { color: #b71c1c; font-size: 14px; }\n\n/* Pasos */\n.offer-pdf-pasos {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  list-style: none;\n  margin: 0 0 20px;\n  padding: 0;\n}\n\n.offer-pdf-pasos li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #333;\n  background: #fff;\n  border: 1px solid #e3e3e3;\n  border-radius: 20px;\n  padding: 5px 14px 5px 6px;\n}\n\n.offer-pdf-paso-num {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #1a9b5a;\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.offer-pdf-pasos li.hecho { padding: 0; }\n.offer-pdf-pasos li.hecho button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 14px 5px 6px;\n  border: none;\n  background: none;\n  font: inherit;\n  font-size: 13px;\n  color: #333;\n  cursor: pointer;\n  border-radius: 20px;\n}\n.offer-pdf-pasos li.hecho button:hover:not(:disabled) { background: #f2f2f2; text-decoration: underline; }\n.offer-pdf-pasos li.hecho button:disabled { cursor: default; color: #999; }\n.offer-pdf-pasos li.actual { color: #111; border-color: #111; font-weight: 600; }\n.offer-pdf-pasos li.actual .offer-pdf-paso-num { background: #111; color: #fff; }\n\n/* Hoja a la izquierda, envío a la derecha */\n.offer-pdf-columnas {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 16px;\n  align-items: start;\n}\n\n/* Envío */\n.offer-pdf-envio {\n  background: #fff;\n  border: 1px solid #e3e3e3;\n  border-radius: 10px;\n  padding: 18px 20px;\n  margin-bottom: 16px;\n}\n\n.offer-pdf-envio h2 { font-size: 15px; font-weight: 600; margin: 0 0 12px; color: #1b1b1b; }\n.offer-pdf-envio p { font-size: 13.5px; color: #666; margin: 0 0 12px; }\n\n.offer-pdf-acciones { display: flex; flex-wrap: wrap; gap: 10px; }\n\n.offer-pdf-secundario,\n.offer-pdf-principal {\n  border-radius: 8px;\n  padding: 9px 16px;\n  font: inherit;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.offer-pdf-secundario { background: #fff; border: 1px solid #bbb; color: #111; }\n.offer-pdf-secundario:hover:not(:disabled) { background: #eee; }\n.offer-pdf-secundario:disabled { background: #eee; color: #999; border-color: #ddd; cursor: default; }\n.offer-pdf-principal { background: #111; border: 1px solid #111; color: #fff; }\n.offer-pdf-principal:hover { background: #333; }\n\n.offer-pdf-estado { font-size: 12.5px; color: #777; margin: 12px 0 0; }\n\n/* Lo que sale de casa: solo la hoja */\n@media print {\n  body { background: #fff !important; }\n  .header, .offer-pdf-pasos, .offer-pdf-lateral { display: none !important; }\n  .offer-pdf { padding: 0; max-width: 100%; }\n  .offer-pdf-columnas { display: block; }\n}\n\n@media (max-width: 900px) {\n  .offer-pdf { padding: 20px 16px 40px; }\n  .offer-pdf-columnas { grid-template-columns: 1fr; }\n  .offer-pdf .offer-pdf-hoja { padding: 20px; min-height: 0; overflow-x: auto; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
